import React from 'react';
import ChartLayout from './components/ChartLayout';


const CenterLayout  = () => {
        return <ChartLayout />
}

export default React.memo(CenterLayout);
